module.exports = __webpack_public_path__ + "img/addtoTP.53cad688.svg";